import ErrorMessage from "component/Common/ErrorMessage";
import { debounce } from "helpers";
import { icons } from "helpers/images";
import React from "react";
import classes from "./style.module.scss";

const InputBox = (props) => {
  let {
    placeholder = "",
    disabled,
    type = "text",
    name = "",
    maxlength = "",
    label = "",
    register,
    onChange,
    value,
    className,
    labelClassName,
    error,
    messages,
    width,
    height,
    defaultValue,
    min,
    max,
    required = false,
    pattern,
    oninvalid,
    title,
    requiredField = false,
    onKeyDown,
    onKeyPress,
    readOnly= false,
    step
  } = props;
  return (
    <>
      {label !== "" && (
        <label className={`${labelClassName ? "fs-12" : ""} profilelabel`}>
          {/* Label content goes here */}
          {label} {required && <span className="text-danger">*</span>}{" "}
        </label>
      )}
      <input
        autoComplete="off"
        ref={register}
        value={value}
        step={step}
        name={name}
        placeholder={placeholder}
        className={`${className} form-control ${disabled && "not-allowed"}`}
        disabled={disabled}
        type={type}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onKeyPress={onKeyPress}
        maxLength={maxlength}
        style={{ width: width, height: height }}
        defaultValue={defaultValue}
        minlength={min}
        max={max}
        pattern={pattern}
        oninvalid={oninvalid}
        title={title}
        onWheel={(e) => e.target.blur()}
        required={requiredField ? "required" : null}
        readOnly={readOnly}
      />
      <ErrorMessage error={error} messages={messages} />
    </>
  )
};
export default InputBox;

InputBox.SearchBox = ({
  placeholder = "Enter here",
  disabled,
  value = "",
  type = "text",
  name = "",
  maxlength = "",
  onChange,
  searchIcon = true,
  label = "",
  register,
  className=''
}) => (
  <>
    {label !== "" && <label className="inputLabel">{label}</label>}
    <div className={`position-relative ${className}`} >
      <input
        ref={register}
        name={name}
        placeholder={placeholder}
        onWheel={(e) => e.target.blur()}
        className={`${classes.searchBoxStyle} ${classes.rightpadding}`}
        onChange={debounce(onChange)}
        disabled={disabled}
        defaultValue={value}
        type={type}
        maxLength={maxlength}
      />
      {searchIcon && (
        <img alt="search" className={classes.rightIcon} src={icons.search} />
      )}
    </div>
  </>
);
